import React from "react";
import OrdersPage from "Common/Components/OrdersPage";

// سفارش‌های تولید شده = سفارش‌هایی که order_status آن‌ها produced است.
// طبق مستند هیچ دکمه‌ای برای تغییر مستقیم وضعیت سفارش در این مرحله وجود ندارد؛
// انتقال به این فهرست و خروج از آن نتیجه تغییر وضعیت قلم‌هاست.
const Index = () => (
  <OrdersPage
    pageTitle="سفارش‌های تولید شده"
    orderStatus="produced"
    emptyText="هیچ سفارش تولید شده‌ای وجود ندارد"
  />
);

export default Index;
